import {
	GET_FROM_EMAILS_LIST_REQUEST,
	GET_FROM_EMAILS_LIST_SUCCESS,
	GET_FROM_EMAILS_LIST_FAILED,
	GET_TO_EMAILS_LIST_REQUEST,
	GET_TO_EMAILS_LIST_SUCCESS,
	GET_TO_EMAILS_LIST_FAILED,
	GET_USERS_LIST_REQUEST,
	GET_USERS_LIST_SUCCESS,
	GET_USERS_LIST_FAILED,
	GET_USERS_LIST_RESET,
	GET_SOURCES_LIST_REQUEST,
	GET_SOURCES_LIST_SUCCESS,
	GET_SOURCES_LIST_FAILED,
	GET_SOURCES_LIST_RESET,
	GET_RETAIN_FILTERS_LIST_REQUEST,
	GET_RETAIN_FILTERS_LIST_SUCCESS,
	GET_RETAIN_FILTERS_LIST_FAILED,
	GET_INFO_SUCCESS,
	GET_REVIEW_OVERVIEW_DETAILS_REQUEST,
	GET_REVIEW_LIST_REQUEST_SUCCESS,
	GET_REVIEW_LIST_REQUEST_FAILED,
	GET_REVIEW_OVERVIEW_DETAILS_SUCCESS,
	GET_REVIEW_OVERVIEW_DETAILS_FAILED,
	GET_USER_REVIEW_OVERVIEW_DETAILS_REQUEST,
	GET_USER_REVIEW_OVERVIEW_DETAILS_SUCCESS,
	GET_USER_REVIEW_OVERVIEW_DETAILS_FAILED,
	GET_DYNAMIC_FROM_EMAILS_LIST_REQUEST,
	GET_DYNAMIC_FROM_EMAILS_LIST_REQUEST_SUCCESS,
	GET_DYNAMIC_FROM_EMAILS_LIST_REQUEST_FAILED,
	GET_DYNAMIC_TO_EMAILS_LIST_REQUEST,
	GET_DYNAMIC_TO_EMAILS_LIST_REQUEST_SUCCESS,
	GET_DYNAMIC_TO_EMAILS_LIST_REQUEST_FAILED,
} from "../types"

const initialState = {
	fromEmailsList: [],
	isFromEmailsLoading: false,
	toEmailsList: [],
	isToEmailsLoading: false,
	usersList: [],
	isLoading: false,
	sourcesList: [],
	isSourcesLoading: false,
	retainedFilterJobData: null,
	isRetainedFilterJobdataLoading: false,
	version: {},
	retainedJobFailed: false,
	isReviewOverviewLoading: false,
	reviewOverviewDetails: null,
	isUserReviewOverviewLoading: false,
	userReviewOverviewDetails: null,
}
// eslint-disable-next-line
export default function (state = initialState, action) {
	switch (action.type) {
		case GET_FROM_EMAILS_LIST_REQUEST:
			return {
				...state,
				isFromEmailsLoading: true,
			}
		case GET_FROM_EMAILS_LIST_SUCCESS:
			return {
				...state,
				isFromEmailsLoading: false,
				fromEmailsList: action.payload,
			}
		case GET_FROM_EMAILS_LIST_FAILED:
			return {
				...state,
				isFromEmailsLoading: false,
				error: action.payload,
			}
		case GET_FROM_EMAILS_LIST_REQUEST:
			return {
				...state,
				error: undefined,
				fromEmailsList: [],
			}
		case GET_TO_EMAILS_LIST_REQUEST:
			return {
				...state,
				isToEmailsLoading: true,
			}
		case GET_TO_EMAILS_LIST_SUCCESS:
			return {
				...state,
				isToEmailsLoading: false,
				toEmailsList: action.payload,
			}
		case GET_TO_EMAILS_LIST_FAILED:
			return {
				...state,
				isToEmailsLoading: false,
				error: action.payload,
			}
		case GET_TO_EMAILS_LIST_REQUEST:
			return {
				...state,
				error: undefined,
				toEmailsList: [],
			}
		case GET_USERS_LIST_REQUEST:
			return {
				...state,
				isLoading: true,
			}
		case GET_USERS_LIST_SUCCESS:
			return {
				...state,
				isLoading: false,
				usersList: action.payload,
			}
		case GET_USERS_LIST_FAILED:
			return {
				...state,
				isLoading: false,
				usersListError: action.payload,
			}
		case GET_USERS_LIST_RESET:
			return {
				...state,
				usersListError: undefined,
				usersList: [],
			}
		case GET_SOURCES_LIST_REQUEST:
			return {
				...state,
				isSourcesLoading: true,
			}
		case GET_SOURCES_LIST_SUCCESS:
			return {
				...state,
				isSourcesLoading: false,
				sourcesList: action.payload,
			}
		case GET_SOURCES_LIST_FAILED:
			return {
				...state,
				isSourcesLoading: false,
				error: action.payload,
				sourcesList: [],
			}
		case GET_RETAIN_FILTERS_LIST_REQUEST:
			return {
				...state,
				isRetainedFilterJobdataLoading: true,
			}
		case GET_RETAIN_FILTERS_LIST_SUCCESS:
			return {
				...state,
				isRetainedFilterJobdataLoading: false,
				retainedFilterJobData: action.payload,
				retainedJobFailed: false,
			}
		case GET_RETAIN_FILTERS_LIST_FAILED:
			return {
				...state,
				isRetainedFilterJobdataLoading: false,
				error: action.payload,
				retainedJobFailed: true,
			}
		case GET_INFO_SUCCESS:
			return {
				...state,
				version: action.payload,
			}
		case GET_REVIEW_OVERVIEW_DETAILS_REQUEST:
			return {
				...state,
				isReviewOverviewLoading: true,
			}
		case GET_REVIEW_OVERVIEW_DETAILS_SUCCESS:
			return {
				...state,
				isReviewOverviewLoading: false,
				reviewOverviewDetails: action.payload,
			}
		case GET_REVIEW_OVERVIEW_DETAILS_FAILED:
			return {
				...state,
				isReviewOverviewLoading: false,
				reviewOverviewDetails: null,
				error: action.payload,
			}
		case GET_USER_REVIEW_OVERVIEW_DETAILS_REQUEST:
			return {
				...state,
				isUserReviewOverviewLoading: true,
			}
		case GET_USER_REVIEW_OVERVIEW_DETAILS_SUCCESS:
			return {
				...state,
				isUserReviewOverviewLoading: false,
				userReviewOverviewDetails: action.payload,
			}
		case GET_USER_REVIEW_OVERVIEW_DETAILS_FAILED:
			return {
				...state,
				isUserReviewOverviewLoading: false,
				userReviewOverviewDetails: null,
				error: action.payload,
			}
		case GET_DYNAMIC_FROM_EMAILS_LIST_REQUEST:
			return {
				...state,
				isFromEmailsLoading: true,
				fromEmailsList: [],
			}
		case GET_DYNAMIC_FROM_EMAILS_LIST_REQUEST_SUCCESS:
			return {
				...state,
				isFromEmailsLoading: false,
				fromEmailsList: action.payload?.data,
			}
		case GET_DYNAMIC_FROM_EMAILS_LIST_REQUEST_FAILED:
			return {
				...state,
				isFromEmailsLoading: false,
			}

		case GET_DYNAMIC_TO_EMAILS_LIST_REQUEST:
			return {
				...state,
				isToEmailsLoading: true,
				toEmailsList: [],
			}
		case GET_DYNAMIC_TO_EMAILS_LIST_REQUEST_SUCCESS:
			return {
				...state,
				isToEmailsLoading: false,
				toEmailsList: action.payload?.data,
			}
		case GET_DYNAMIC_TO_EMAILS_LIST_REQUEST_FAILED:
			return {
				...state,
				isToEmailsLoading: false,
			}

		default:
			return state
	}
}
